angular
  .module('surfsightApp.controllers')
  .controller('OrganizationUserAccessPermissionsAddController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    'dataFromCaller',
    'edgeGroupFactoryV2',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      dataFromCaller,
      edgeGroupFactoryV2
    ) {
      $scope.UserPermissions = {}
      $scope.UserPermissions.organizationId = parseInt(
        dataFromCaller.organizationId
      )
      $scope.UserPermissions.role = ''
      $scope.UserPermissions.user_id = parseInt(dataFromCaller.user_id)
      $scope.UserPermissions.everything = false

      $scope.UserPermissions.organizationAccessEdgeGroupIds = []

      $scope.organizationId = parseInt(dataFromCaller.organizationId)

      $scope.cancel = function () {
        $mdDialog.cancel()
      }

      $scope.getUserAccessPermissions = function () {
        var request_json = {
          method: 'GET',
          url:
            USER_BASEURL +
            '/userPermissions/' +
            $scope.UserPermissions.user_id +
            '/' +
            $scope.organizationId,
          data: $scope.UserPermissions
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              $scope.UserPermissions.organizationAccessEdgeGroupIds =
                response.data.user_permissions.organizationAccessEdgeGroupIds
              $scope.UserPermissions.everything =
                response.data.user_permissions.everything
              $scope.UserPermissions.role = response.data.user_permissions.role
            } else {
            }
          },
          function (response) {
            if (response && response.data) {
              if (response.data.statusCode == 401) {
                $state.go('home.login')
              }
            } else {
              alert('Error occurred.')
            }
          }
        )
      }

      $scope.load_organizationsEdgeGroups = function () {
        $scope.getUserAccessPermissions()
        $scope.organizationEdgeGroups = []
        $scope.loading = true
        edgeGroupFactoryV2.getGroups($scope.organizationId).then(
          function (response) {
            if (response.data && response.data.data) {
              $scope.organizationEdgeGroups = response.data.data
            }
            $scope.loading = false
          },
          function () {
            alert('Error Occurred')
            $scope.loading = false
          }
        )
      }
      $scope.load_organizationsEdgeGroups()

      $scope.organizationsIDs = []

      $scope.selectAll = function () {
        $scope.organizationsIDs = [-1]

        if (
          $scope.UserPermissions.organizationAccessEdgeGroupIds.indexOf(-2) ==
          -1
        ) {
          $scope.organizationEdgeGroups.forEach(function (edgeGroup) {
            $scope.organizationsIDs.push(edgeGroup.id)
          })
          $scope.UserPermissions.organizationAccessEdgeGroupIds =
            $scope.organizationsIDs
          $scope.UserPermissions.everything = true
        } else {
          $scope.UserPermissions.organizationAccessEdgeGroupIds = [-2]
        }
      }
      $scope.deSelectEverything = function () {
        var index = $scope.UserPermissions.organizationAccessEdgeGroupIds.indexOf(
          -2
        )
        if (index > -1) {
          $scope.UserPermissions.organizationAccessEdgeGroupIds.splice(index, 1)
        }
      }
      $scope.addUser = function () {
        var organization_edgegroupids = []
        var organization_edgegroupids_dump = []
        if ($scope.UserPermissions.organizationAccessEdgeGroupIds.length == 0) {
          $scope.showMessageToast('Please select the edge groups')
          return false
        } else {
          var request_json = {
            method: 'POST',
            url:
              USER_BASEURL +
              '/userPermissions/' +
              $scope.UserPermissions.user_id +
              '/' +
              $scope.organizationId,
            data: $scope.UserPermissions
          }
          $http(request_json).then(
            function (response) {
              if (response.data.status.code == 0) {
                $mdDialog.hide(response)
              } else {
                var toast = $mdToast
                  .simple()
                  .textContent(response.data.status.error)
                  .action('ok')
                  .position('bottom')
                  .actionKey('F1')
                  .hideDelay(5000)
                  .parent('#add-user-container')

                $mdToast
                  .show(toast)
                  .then(function (response) {
                    if (response == 'ok') {
                    }
                  })
                  .catch(() => {})
              }
            },
            function (response) {
              if (response && response.data) {
                if (response.data.statusCode == 401) {
                  $state.go('home.login')
                }
              } else {
                alert('Error occurred.')
              }
            }
          )
        }
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action('ok')
          .position('bottom')
          .hideDelay(5000)
          .actionKey('F1')
          .parent('#add-user-container')

        $mdToast
          .show(toast)
          .then(function (response) {})
          .catch(() => {})
      }
      $scope.closeSelectBox = function () {
        angular.element('md-backdrop').trigger('click')
      }
    }
  ])
